<template>
  <v-form @submit="login" ref="form" class="fields">
    <UserField />
    <PasswordField />

    <ButtonWidget
      text-color="white"
      height="40px"
      type="submit"
      :align="smAndDown ? 'center' : 'left'"
      :loading="loading"
    >
      {{ btnText }}
    </ButtonWidget>

    <v-snackbar
      v-model="snackbarOpen"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      centered
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          @click="snackbarOpen = false"
          color="white"
          text
          icon
          small
        >
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import UserField from "./fields/UserField.vue";
import PasswordField from "./fields/PasswordField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _data = {
  btnText: "Acessar",
  loading: false,
  snackbarOpen: false,
  snackbarText: "Lorem Ipsum",
  snackbarColor: "Grey",
  snackbarTimeout: 3000,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    notificate(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbarOpen = true;
    },
    login(event) {
      event.preventDefault();

      const form = this.$refs.form;
      this.loading = true;

      if (form.validate()) {
        const data = Object.fromEntries(new FormData(form.$el).entries());

        this.$auth
          .login(data)
          .then(() => this.$router.push("/pesquisas"))
          .catch(() => {
            this.notificate("E-mail e/ou senha incorretos.", "red");
            this.loading = false;
          });
      }
    },
  },
  components: {
    ButtonWidget,
    UserField,
    PasswordField,
  },
};
</script>

<style lang="scss" scoped>
.fields {
  display: grid;
  gap: 24px;
  grid-template-columns: 320px 320px auto;

  @media screen and (max-width: 959.9px) {
    grid-template-columns: minmax(0, 320px);
  }
}
</style>
